module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	fox.registerWidget('Layout_404', {

		configure: function(options) {
			options.pageContainer = '.page-404';
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/layout/404.js
// module id = 121
// module chunks = 4